export default __webpack_public_path__ + "static/media/ad.bfdd4c1c.gif";